import StatamicObject from "./statamicObject"
import i18n from "i18next"
import dateFormat from "../utils/dateFormat"

export default class Article extends StatamicObject {
  constructor(data) {
    super(data)
    Object.assign(this, data)
  }

  getDate() {
    if (!this.date) {
      return null
    }

    return dateFormat(this.date, i18n.language)
  }
}
